module.exports = __webpack_public_path__ + "img/driving-sales-home-for-the-holidays-img-1.45bc4122.webp";